import {Updatable} from '@fantasmagames/core/src/update/Updatable';


export class Emitter extends Updatable {

    private _baseEmitter: PIXI.particles.Emitter;

    constructor(particleParent: PIXI.Container, particleImages: any, config: any) {
        super(true);

        this._baseEmitter = new PIXI.particles.Emitter(particleParent, particleImages, config);
    }

    public get emit(): boolean {
        return this._baseEmitter.emit;
    }

    public set emit(value: boolean) {
        this._baseEmitter.emit = value;
    }

    public get particleConstructor(): PIXI.particles.ParticleConstructor {
        return this._baseEmitter.particleConstructor;
    }

    public set particleConstructor(value: PIXI.particles.ParticleConstructor) {
        this._baseEmitter.particleConstructor = value;
    }

    public update(dt: number): void {
        this._baseEmitter.update(dt);
    }

    public stop(): void {
        super.stop();

        this._baseEmitter.destroy();
    }

    public get baseEmitter(): PIXI.particles.Emitter {
        return this._baseEmitter;
    }
}


// WEBPACK FOOTER //
// ./@fantasmagames/core/src/particles/Emitter.ts